import { createContext, PropsWithChildren, useContext } from 'react';
import { InertiaFormProps } from '@inertiajs/react';

export const FormContext = createContext<InertiaFormProps<any> | null>(null);

export const FormProvider = <TForm extends object>({ value, children }: PropsWithChildren<{
    value: InertiaFormProps<TForm>
}>) => {
    return (
        <FormContext.Provider value={value as any}>
            {children}
        </FormContext.Provider>
    );
};

export const useForm = () => useContext(FormContext);
